import { retrieveToken } from '../storage';
import {
  wrapFetch,
  ApiError,
  apiFetch,
  apiError,
  REGISTRAZIONE_DATI_NON_CORRETTI,
  REGISTRAZIONE_EMAIL_DUPLICATA,
  SALVATAGGIO_DATI_NON_CORRETTI,
} from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getEserciziCommerciali = (
  gruppoId,
  consulenteId,
  gestioneOperativaSeparata,
  responsabileSicurezzaId,
  page,
  size,
  sortby,
) => {
  const token = retrieveToken();
  const PATH = '/api/esercizi_commerciali';
  let query = `?page=${page}&size=${size}&sort=${sortby}&${sortby}.dir=ASC`;
  if (gruppoId !== null && gruppoId !== -1) {
    // NB: -1 is a special value used for "all records" in dropdown menu.
    query = query + '&gruppoId.equals=' + gruppoId;
  }
  if (consulenteId !== null) {
    query = query + '&consulenteId.equals=' + consulenteId;
  }
  if (responsabileSicurezzaId != null) {
    query =
      query + '&responsabileSicurezzaId.equals=' + responsabileSicurezzaId;
  }
  if (
    gestioneOperativaSeparata !== null &&
    gestioneOperativaSeparata !== undefined
  ) {
    query += `&gestioneOperativaSeparata.equals=${gestioneOperativaSeparata}`;
  }

  const URL = BASE_URL + PATH + query;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getEserciziCommercialiFiltered = (
  gruppoId,
  consulenteId,
  responsabileSicurezzaId,
  page,
  size,
  sortby,
  email,
  nome,
  esercizioId,
  ragioneSociale,
  partitaIva,
  telefono,
  cittaSede,
  gestioneOperativaSeparata,
) => {
  const token = retrieveToken();
  const PATH = '/api/esercizi_commerciali';
  let query = `?page=${page}&size=${size}&sort=${sortby}&${sortby}.dir=ASC`;

  if (gruppoId !== null && gruppoId !== -1) {
    // NB: -1 is a special value used for "all records" in dropdown menu.
    query += '&gruppoId.equals=' + gruppoId;
  }
  if (consulenteId !== null && consulenteId !== '') {
    query += '&consulenteId.equals=' + consulenteId;
  }
  if (responsabileSicurezzaId != null) {
    query += '&responsabileSicurezzaId.equals=' + responsabileSicurezzaId;
  }
  if (email !== null && email !== '') {
    query += `&emailGestore.contains=${encodeURIComponent(email)}`;
  }
  if (nome !== null && nome !== '') {
    query += `&nome.contains=${encodeURIComponent(nome)}`;
  }
  if (esercizioId) {
    query += `&id.equals=${esercizioId}`;
  }
  if (ragioneSociale) {
    query += `&ragioneSociale.contains=${encodeURIComponent(ragioneSociale)}`;
  }
  if (partitaIva) {
    query += `&partitaIva.contains=${encodeURIComponent(partitaIva)}`;
  }
  if (telefono) {
    query += `&telefono.contains=${encodeURIComponent(telefono)}`;
  }
  if (cittaSede) {
    query += `&cittaSede.contains=${encodeURIComponent(cittaSede)}`;
  }
  if (
    gestioneOperativaSeparata !== null &&
    gestioneOperativaSeparata !== undefined
  ) {
    query += `&gestioneOperativaSeparata.equals=${gestioneOperativaSeparata}`;
  }
  const URL = BASE_URL + PATH + query;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getEsercizioCommerciale = (esercizioId) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/esercizi_commerciali_giorni/' + esercizioId;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      404: 'Errore durante il caricamento dei dati: esercizio commerciale non trovato.',
    }),
  );
};

export const getEserciziCommercialiByIds = (eserciziIds) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = `/api/esercizi_commerciali/by-ids?ids=${eserciziIds}`;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      404: 'Errore durante il caricamento dei dati: esercizi commercial non trovati.',
    }),
  );
};

export const getCountEserciziCommerciali = (
  gruppoId,
  consulenteId,
  email,
  nome,
  esercizioId,
  ragioneSociale,
  partitaIva,
  telefono,
  cittaSede,
  gestioneOperativaSeparata = null,
) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/esercizi_commerciali/count';
  let URL = BASE_URL + PATH;

  // Each filter stands on its own, exactly as in getEserciziCommercialiFiltered:
  // the count and the list back the same table, so any filter that narrows one
  // has to narrow the other. Nesting these tests inside a check on gruppoId and
  // consulenteId makes the two disagree.
  const params = [];
  if (gruppoId !== null && gruppoId !== -1) {
    params.push('gruppoId.equals=' + gruppoId);
  }
  if (consulenteId !== null) {
    params.push('consulenteId.equals=' + consulenteId);
  }
  if (email !== null && email !== '' && email !== undefined) {
    params.push(`emailGestore.contains=${encodeURIComponent(email)}`);
  }
  if (nome !== null && nome !== '' && nome !== undefined) {
    params.push(`nome.contains=${encodeURIComponent(nome)}`);
  }
  if (esercizioId) {
    // `id.equals`, the name the backend criteria declares — the list function
    // and getCountEserciziCommercialiForReplica both send it too.
    params.push(`id.equals=${esercizioId}`);
  }
  if (ragioneSociale) {
    params.push(
      `ragioneSociale.contains=${encodeURIComponent(ragioneSociale)}`,
    );
  }
  if (partitaIva) {
    params.push(`partitaIva.contains=${encodeURIComponent(partitaIva)}`);
  }
  if (telefono) {
    params.push(`telefono.contains=${encodeURIComponent(telefono)}`);
  }
  if (cittaSede) {
    params.push(`cittaSede.contains=${encodeURIComponent(cittaSede)}`);
  }
  if (
    gestioneOperativaSeparata !== null &&
    gestioneOperativaSeparata !== undefined
  ) {
    params.push(
      `gestioneOperativaSeparata.equals=${gestioneOperativaSeparata}`,
    );
  }
  if (params.length > 0) {
    URL += `?${params.join('&')}`;
  }
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const registerEsercizioAsAdmin = (requestBody) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/esercizi_commerciali_giorni';
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      // 404 if the gruppoId does not correspond to a registered Gruppo
      400: REGISTRAZIONE_DATI_NON_CORRETTI,
      404: REGISTRAZIONE_DATI_NON_CORRETTI,
    }),
  );
};

export const registerEsercizioWithResponsabile = (requestBody) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/esercizi_commerciali_giorni_consulente';
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      // 404 if the gruppoId does not correspond to a registered Gruppo
      400: REGISTRAZIONE_DATI_NON_CORRETTI,
      404: REGISTRAZIONE_DATI_NON_CORRETTI,
      409: REGISTRAZIONE_EMAIL_DUPLICATA,
    }),
  );
};

export const updateEsercizioCommerciale = (requestBody) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/esercizi_commerciali_giorni';
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: 'Errore salvataggio: esercizio commerciale non trovato.',
    }),
  );
};

export const sendEmailToConfirmRegistration = (esercizioCommercialeId) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/esercizi_commerciali/invio_mail/' + esercizioCommercialeId;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      400: 'Registrazione esercizio già confermata.',
    }),
  );
};

export const sendEmailToAlertEsercizioAndConsulente = (
  esercizioCommercialeId,
) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH =
    '/api/esercizi_commerciali/invio_mail_notifica_rinnovo/' +
    esercizioCommercialeId;
  const URL = BASE_URL + PATH;
  // The only endpoint that does not fall back to the generic sentence of
  // `ApiError`, nor to 'Operazione non consentita.' on a 403: every status it
  // does not name answers 'Errore generico'. `apiError` has no room for that,
  // and inventing one for a single caller would cost more than the closure.
  const errorFunction = (status) => {
    let message = 'Errore generico';
    if (status === 400) {
      message = 'Attenzione, richiesta non valida';
    }
    return new ApiError(status, message);
  };
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
    }),
    errorFunction,
  );
};

export const getFunzionalitaApp = (esercizioCommercialeId) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = `/api/funzionalitaApp/${esercizioCommercialeId}`;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const updateFunzionalitaApp = (requestBody) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = '/api/funzionalitaApp';
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: 'Errore salvataggio: esercizio commerciale non trovato.',
    }),
  );
};

export const getAllControlsCompliantStatus = (esercizioCommercialeId) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = `/api/controlli_conformita/get_tutti_conformi_status/consulente?idEsercizioCommerciale=${esercizioCommercialeId}`;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const updateAllControlsCompliantStatus = (requestBody) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = '/api/esercizio_commerciale/stato_tutti_conformi';
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: 'Errore salvataggio: esercizio commerciale non trovato.',
    }),
  );
};

export const getCountEserciziCommercialiForReplica = (
  gruppoId,
  consulenteId,
  email,
  nome,
  esercizioId,
  ragioneSociale,
  partitaIva,
  telefono,
  cittaSede,
  gestioneOperativaSeparata = null,
) => {
  const token = retrieveToken();
  const PATH = '/api/esercizi_commerciali/count';
  let query = `?`;

  if (gruppoId !== null && gruppoId !== -1) {
    // NB: -1 is a special value used for "all records" in dropdown menu.
    query += '&gruppoId.equals=' + gruppoId;
  }
  if (consulenteId !== null && consulenteId !== '') {
    query += '&consulenteId.equals=' + consulenteId;
  }
  if (email !== null && email !== '') {
    query += `&emailGestore.contains=${encodeURIComponent(email)}`;
  }
  if (nome !== null && nome !== '') {
    query += `&nome.contains=${encodeURIComponent(nome)}`;
  }
  if (esercizioId) {
    query += `&id.equals=${esercizioId}`;
  }
  if (ragioneSociale) {
    query += `&ragioneSociale.contains=${encodeURIComponent(ragioneSociale)}`;
  }
  if (partitaIva) {
    query += `&partitaIva.contains=${encodeURIComponent(partitaIva)}`;
  }
  if (telefono) {
    query += `&telefono.contains=${encodeURIComponent(telefono)}`;
  }
  if (cittaSede) {
    query += `&cittaSede.contains=${encodeURIComponent(cittaSede)}`;
  }
  if (
    gestioneOperativaSeparata !== null &&
    gestioneOperativaSeparata !== undefined
  ) {
    query += `&gestioneOperativaSeparata.equals=${gestioneOperativaSeparata}`;
  }
  const URL = BASE_URL + PATH + query;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getEserciziCommercialiFilteredForReplica = (
  gruppoId,
  consulenteId,
  responsabileSicurezzaId,
  page,
  size,
  sortby,
  email,
  nome,
  esercizioId,
  ragioneSociale,
  partitaIva,
  telefono,
  cittaSede,
  gestioneOperativaSeparata,
  id,
) => {
  const token = retrieveToken();
  const PATH = '/api/esercizi_commerciali';
  let query = `?page=${page}&size=${size}&sort=${sortby}&${sortby}.dir=ASC`;

  if (gruppoId !== null && gruppoId !== -1) {
    // NB: -1 is a special value used for "all records" in dropdown menu.
    query += '&gruppoId.equals=' + gruppoId;
  }
  if (consulenteId !== null && consulenteId !== '') {
    query += '&consulenteId.equals=' + consulenteId;
  }
  if (responsabileSicurezzaId != null) {
    query += '&responsabileSicurezzaId.equals=' + responsabileSicurezzaId;
  }
  if (email !== null && email !== '') {
    query += `&emailGestore.contains=${encodeURIComponent(email)}`;
  }
  if (nome !== null && nome !== '') {
    query += `&nome.contains=${encodeURIComponent(nome)}`;
  }
  if (esercizioId) {
    query += `&id.equals=${esercizioId}`;
  }
  if (ragioneSociale) {
    query += `&ragioneSociale.contains=${encodeURIComponent(ragioneSociale)}`;
  }
  if (partitaIva) {
    query += `&partitaIva.contains=${encodeURIComponent(partitaIva)}`;
  }
  if (telefono) {
    query += `&telefono.contains=${encodeURIComponent(telefono)}`;
  }
  if (cittaSede) {
    query += `&cittaSede.contains=${encodeURIComponent(cittaSede)}`;
  }
  if (
    gestioneOperativaSeparata !== null &&
    gestioneOperativaSeparata !== undefined
  ) {
    query += `&gestioneOperativaSeparata.equals=${gestioneOperativaSeparata}`;
  }
  if (id) {
    query += `&id.notEquals=${id}`;
  }
  const URL = BASE_URL + PATH + query;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
